import { Box, CssBaseline } from '@mui/material';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import LPAppBar from '../../app/components/LPAppBar';
import LPDrawer from '../../app/components/LPDrawer';
import ShiftHome from '../../app/components/ShiftHome';
import { useStyles } from '../../assets/styles/DefaultPageStyle';
import Utils from '../../felles/Utils';
import MenuItemTarget from '../../models/MenuItemTarget';
import UISize from '../../models/UISize';
import * as actions from '../../store/actions/index';
import { AppState } from '../../store/rootReducer';
import SS13OrderDays from './SS13OrderDays';

// SS13 "Salg pr. dag" - orders per order date. The page keeps its own state (no saga/reducer).
export default function SS13Page() {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const screenSize: UISize = useSelector(state => (state as AppState).ui.screenSize);
  const open = screenSize.width > 0 && screenSize.width < 1200 ? false : true;
  const navigate = useNavigate();
  const n: MenuItemTarget = useSelector((state) => (state as AppState).menuItem.menuItemTarget);
  const button: boolean = useSelector((state) => (state as AppState).ui.isSandwichButtonTurnedOn);

  const handlePressedKey = (event: any) => {
    const { key } = event;
    if ((event.shiftKey && key === 'F7') || key === 'F8') {
      event.preventDefault();
    }
    if ((event.shiftKey && key === 'End') || key === 'F3') {
      event.preventDefault();
      dispatch(actions.menuItemSetTarget(new MenuItemTarget(n.rootItem, n.item !== '' ? n.item : n.rootItem, '', '', n.tilpasset, n.prodSynlig
        , n.kodeSynlig, n.labelSynlig, n.menuSynlig, n.hasChildren, n.title)));
      dispatch(actions.menuItemSetSelected([n.rootItem, n.item + n.rootItem]));
      navigate(Utils.HOMEPAGE_CONTEXT + '/menu');
    }
  };

  return (
    <div className={classes.root} tabIndex={0} onKeyDown={(e) => handlePressedKey(e)}>
      <ShiftHome />
      <CssBaseline />
      <LPDrawer />
      <main
        className={clsx(classes.content, { [classes.contentShift]: button ? true : open })}
        style={{ overflow: 'hidden', height: 'calc(100vh - 45px)', display: 'flex', flexDirection: 'column' }}
      >
        <LPAppBar ismenuvisible={true} />
        {/* Fills the rest of the window: the day table scrolls inside it. */}
        <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
          <SS13OrderDays />
        </Box>
      </main>
    </div>
  );
}
